import Service from "../ResourceService";

const urlEndPoint = "guest";
const LanguageService = {
    GetResourceLanguage: (param:string): Promise<any> => {
        return Service.get(`${urlEndPoint}/GetResourceLanguage?param=${param}`);
    }
}

export default LanguageService;